import { render } from "./InputMultiplaEscolhaPreenchimento.vue?vue&type=template&id=734f6458&scoped=true"
import script from "./InputMultiplaEscolhaPreenchimento.vue?vue&type=script&lang=js"
export * from "./InputMultiplaEscolhaPreenchimento.vue?vue&type=script&lang=js"

import "./InputMultiplaEscolhaPreenchimento.vue?vue&type=style&index=0&id=734f6458&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734f6458"],['__file',"src/components/VisualizarForm/components/InputMultiplaEscolhaPreenchimento.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "734f6458"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('734f6458', __exports__)) {
    console.log('reload')
    api.reload('734f6458', __exports__)
  }
  
  module.hot.accept("./InputMultiplaEscolhaPreenchimento.vue?vue&type=template&id=734f6458&scoped=true", () => {
    console.log('re-render')
    api.rerender('734f6458', render)
  })

}


export default __exports__